import { __assign } from './external/tslib/tslib.es6.js';
import * as React from 'react';

var SvgFilterOutline = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M20 6H4v2h16V6ZM17 11H7v2h10v-2ZM10 16h4v2h-4v-2Z", fill: "currentColor" }))); };

export { SvgFilterOutline as default };
